import styled from 'styled-components';
import { BASE_FONT } from '../../theme/fonts';

export const Header = styled.div`
    width: 100%;
    left: 0px;
    top: 0px;
    flex-direction: row;
    justify-content: space-between;
    padding-top: 25px;
    padding-bottom: 25px;
    padding-left: 25px;
    padding-right: 27px;
    border: 1px solid #eaecf0;

    display: flex;
    align-items: center;
`;

export const HeaderTitle = styled.div`
    font-family: Azo Sans;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 22px;

    display: flex;
    align-items: center;
    letter-spacing: -0.408px;

    color: #202531;
`;

export const CloseButton = styled.button`
    border: 0;
    padding: 0;
    background: white;
    &:hover {
        cursor: pointer;
    }
`;

export const CloseButtonText = styled.em`
    font-size: 24px;
`;

export const Content = styled.div`
    background: #fbfbfb;
    padding: 20px;
    max-height: 600px;
    overflow-y: scroll;
`;

export const AvailablePlan = styled(BASE_FONT)`
    margin-top: 20px;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;

    /* identical to box height, or 150% */

    color: #000000;
    margin-bottom: 12px;
`;

export const AvailablePlansWrapper = styled.div`
    width: 100%;
    display: flex;
    flex: 1;
    flex-wrap: wrap;
    gap: 15px;
    flex-grow: 0;
    flex-shrink: 0;

    flex-basis: 100%;
`;

export const Footer = styled.div`
    width: 100%;
    height: 73px;
    left: 0px;
    bottom: 0px;

    background: #ffffff;
    border-top: 1px solid #eaecf0;
    box-shadow: inset 0px -1px 0px #e1e1e1;
    display: flex;
    align-items: center;
    justify-content: center;
`;
